/**
 * Kiểm tra xem thiết bị hiện tại có phải là thiết bị di động (mobile/tablet) hay không.
 * Kết hợp kiểm tra User Agent và khả năng cảm ứng.
 * @returns {boolean} True nếu là thiết bị di động, ngược lại là false.
 */
function isMobileDevice(): boolean {
	// Kiểm tra User Agent
	const userAgent = navigator.userAgent.toLowerCase();
	const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

	// Kiểm tra khả năng cảm ứng
	// const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

	// Kiểm tra kích thước màn hình tại thời điểm khởi tạo
	const mediaQuery = window.matchMedia('(max-width: 600px)');
	const isSmallScreen = mediaQuery.matches;
	// Trả về true nếu một trong các điều kiện thỏa mãn
	return isMobileUA || isSmallScreen;
}

export default isMobileDevice;
